import React from "react";
import classes from "./PageHeader.module.less";

interface Props {
    title: string;
    subtitle?: string;
    extra?: React.ReactNode;
    size?: "default" | "small";
}

export const PageHeader: React.FC<Props> = ({ title, subtitle, extra, size = "default" }) => (
    <div className={`${classes.header} ${size === "small" ? classes.small : ""}`}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 16 }}>
            <div>
                <h1 className={classes.title}>{title}</h1>
                {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
            </div>
            {extra}
        </div>
    </div>
);
